import { Box, CircularProgress } from '@mui/material';

import { ChildrenProps } from 'types';
import { useAppSelector } from 'store';
import { selectIsLoading } from 'store/slices/loader';

export const LoaderRedux = ({ children }: ChildrenProps) => {
  const isLoading = useAppSelector(selectIsLoading);
  return (
    <>
      {isLoading && (
        <Box
          sx={{
            inset: 0,
            zIndex: 2000,
            display: 'flex',
            position: 'fixed',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(20px)',
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {children}
    </>
  );
};
